import DropDown from "../Dropdown/DropDown";
import { CartContext } from "../../providers/CartContextProvider";
import { useContext, useEffect, useState } from "react";
import { Spinner } from "@nextui-org/react";
import { Authorization } from "../../providers/AuthContextProvider";
import useAxios from "../../hooks/useAxios";

const Address = () => {
    const { AxiosPrivate } = useAxios()
    const { state, dispatch } = useContext(CartContext)
    const { user } = useContext(Authorization)

    const [address, setAddress] = useState({})
    const [loading, setLoading] = useState({ pro: true, city: true, sub: false })

    const [provinces, setProvinces] = useState([])
    const [province, setProvince] = useState(8);
    const [cities, setCities] = useState([])
    const [error, setError] = useState('')
    const [disabled, setDisabled] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target
        setAddress(prev => {
            return { ...prev, [name]: value }
        })
    };

    useEffect(() => {
        const get = async () => {
            setLoading(prev => ({ ...prev, city: true }))
            await AxiosPrivate.get('province')
                .then(res => {
                    setProvinces(res.data.data)
                    handleProvince(null, 8, 'تهران')
                })
                .catch(err => alert(err.response?.data.message || 'استان ها پیدا نشدند'))
                .finally(() => setLoading(prev => ({ ...prev, pro: false })))
            dispatch({ type: "ADD_ADDRESS", payload: [] })
        }
        get()
    }, [])

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get(`city?province=${province}`)
                .then(res => {
                    const { data } = res.data
                    setCities(data)
                    const isTehran = data.find(e => e.id === 399)
                    setAddress(prev => ({ ...prev, city_id: (isTehran ? isTehran.value : data[0].id), city: isTehran ? isTehran.name : data[0].name }))
                    setLoading(prev => ({ ...prev, city: false }))
                })
                .catch(err => alert(err.response?.data.message || 'شهر ها پیدا نشدند'))
                .finally(() => setLoading(prev => ({ ...prev, city: false })))
        }
        get()
    }, [province])

    const handleProvince = (_, value, name) => {
        setProvince(value);
        setLoading(prev => ({ ...prev, city: true }));
        setAddress(prev => ({ ...prev, province: name, province_id: value }))
    }

    const handleAddress = async () => {
        setError('')
        if (!address.city_id || !address.postal_code?.length || !address.text?.trim().length || !(address.text.length > 5)) setError('همه قسمت ها باید به درستی پر شود')
        else if (!(/\b(?!(\d)\1{3})[13-9]{5}[0-9]{5}\b/).test(address.postal_code)) setError('کد پستی معتبر نیست')
        else if (!disabled && (!address.name?.trim().length || !address.number?.trim().length)) setError('مشخصات گیرنده معتبر نیست')
        else if (disabled && !user.first_name?.trim().length) setError('نام و نام خانوادگی برای حساب شما ثبت نشده است')
        else {
            setLoading({ ...loading, sub: true })
            await AxiosPrivate.get('/shipping-cost')
                .then(res => {
                    if (address.province_id === 8)
                        dispatch({ type: "ADD_ADDRESS", payload: { ...address, cost: Number(res.data.data.tehran) } })
                    else dispatch({ type: "ADD_ADDRESS", payload: { ...address, cost: Number(res.data.data.other) } })
                })
                .catch(err => alert(err.response?.data.message))
                .finally(() => setLoading({ ...loading, sub: false }))
        }
    }

    return (
        <>
            <div
                className="w-full rounded-lg overflow-hidden grid lg:grid-cols-4 lg:gap-0 gap-3 bg-white bg-opacity-35 backdrop-blur-md">
                <div className="lg:col-span-3 col-span-4 lg:order-last flex flex-col p-3 gap-4" dir="rtl">
                    <p className="text-xl font-semibold">افزودن آدرس : <span
                        className="text-base text-red-500">{error}</span></p>
                    <form className="flex flex-col gap-3" dir="rtl">
                        <div className="grid sm:grid-cols-3 grid-cols-1 gap-3">
                            <div className={`relative w-full centerOfParent gap-2`}>
                                <label htmlFor="outlined_7">گیرنده سفارش خودم هستم</label>
                                <input type="checkbox" className="accent-primary" name="" id="outlined_7"
                                    onChange={(e) => setDisabled(e.target.checked)} />
                            </div>
                            <div className={`relative w-full`}>
                                <input disabled={disabled} type={'text'} id={`outlined_6`} name={'name'}
                                    value={address.name} onChange={handleChange}
                                    className={`block px-2.5 pb-2.5 pt-4 w-full h-full bg-white text-sm text-gray-900 bg-transparent rounded-lg border-1  appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} />
                                <label htmlFor={`outlined_6`}
                                    className={`absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>نام
                                    گیرنده</label>
                            </div>
                            <div className={`relative w-full`}>
                                <input disabled={disabled} dir="ltr" type={'tel'} id={`outlined_7`} name={'number'}
                                    value={address.number} onChange={handleChange}
                                    className={`block px-2.5 pb-2.5 pt-4 w-full h-full bg-white text-sm text-gray-900 bg-transparent rounded-lg border-1  appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} />
                                <label htmlFor={`outlined_7`}
                                    className={`absolute text-nowrap rounded-lg text-sm duration-300 transform  -translate-y-4 scale-75 top-2 z-10 origin-[10] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>شماره
                                    تماس گیرنده</label>
                            </div>
                            <div className="centerOfParent w-full">
                                {!loading.pro ? <DropDown required={true}
                                    array={provinces} label Searchable defaultValue={province}
                                    placeHolder="استان" setState={handleProvince} name="province"
                                    className='!px-2.5 !pb-2.5 !pt-4 rounded-lg bg-white' />
                                    : <Spinner size="sm" />
                                }
                            </div>
                            <div className="centerOfParent w-full">
                                {!loading.city ? <DropDown required={true}
                                    array={cities} label Searchable defaultValue={address.city_id}
                                    placeHolder="شهر"
                                    setState={(_, value, name) => setAddress(prev => {
                                        return { ...prev, city_id: value, city: name }
                                    })} name="city_id"
                                    className='!px-2.5 !pb-2.5 !pt-4 rounded-lg bg-white' />
                                    : <Spinner size="sm" />
                                }
                            </div>
                            <div className={`relative w-full`}>
                                <input dir="ltr" type={'number'} id={`outlined_5`} name={'postal_code'}
                                    value={address.postal_code} onChange={handleChange}
                                    className={`block px-2.5 pb-2.5 pt-4 w-full h-full bg-white text-sm text-gray-900 bg-transparent rounded-lg border-1  appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} />
                                <label htmlFor={`outlined_5`}
                                    className={`absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>کد
                                    پستی</label>
                            </div>

                        </div>
                        <div className="relative w-full">
                            <textarea rows="5" name='text' value={address.text} onChange={handleChange}
                                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 resize-none bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer bg-white"
                                placeholder="جزئیات آدرس"
                            />
                        </div>
                        <button type="button" disabled={(loading.pro || loading.city || loading.sub)}
                            onClick={handleAddress} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br self-end
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-32 py-2.5 text-center me-2">ثبت
                        </button>
                    </form>
                </div>
                <div className="lg:col-span-1 col-span-4 p-4 flex flex-col gap-3 border-r" dir="rtl">
                    {Object.keys(state.address).length ?
                        <div>
                            <p>خرید شما به این آدرس ارسال خواهد شد :</p>
                            <ul className="flex flex-col">
                                <li className="p-1 text-gray00">استان: <span
                                    className="font-bold">{state.address.province}</span></li>
                                <li className="p-1 text-gray00">شهر: <span
                                    className="font-bold">{state.address.city}</span></li>
                                <li className="p-1 text-gray00">کدپستی: <span
                                    className="font-bold">{state.address.postal_code}</span></li>
                                <li className="p-1 text-gray00">آدرس: <p
                                    className="font-bold text-justify whitespace-break-spaces break-words">{state.address.text}</p>
                                </li>
                                <p>مشخصات گیرنده :</p>
                                <li className="p-1 text-gray00">نام: <span
                                    className="font-bold">{!disabled ? state.address.name : user.first_name + ' ' + user.last_name}</span>
                                </li>
                                <li className="p-1 text-gray00">موبایل: <span
                                    className="font-bold">{!disabled ? state.address.number : user.mobile}</span></li>
                            </ul>
                        </div>
                        : <p>آدرسی ثبت نشده است.</p>}
                </div>
            </div>
        </>
    );
};

export default Address;